module.exports = __webpack_public_path__ + "img/dm.cc0e7a37.svg";